<script>
    import toast from '../../services/toast'
    import Icon from '../../components/Icon.svelte'
    import sessionStore from 'store/session'
    import { getCallLogs as GetCallLogs, getCallLog as GetCallLog } from '../../domain/call/logs.action'
    import { onMount } from "svelte"
    import AuthHeader from '../../components/AuthHeader.svelte'
    import AuthFooter from '../../components/AuthFooter.svelte'
    import InfiniteScroll from 'svelte-infinite-scroll'
    import { AmplitudeLogger, copyText, formatNumber, pickOutInitials, EVENTS } from '../../services/utils';
    import { fly } from 'svelte/transition';
    import { backInOut } from 'svelte/easing';
    import moment from 'moment';
    import { initiateCall } from '../../domain/call/telephony.actions';
    import { useNavigate } from 'svelte-navigator';
    import { saveCallNote as SaveCallNote, updateCallNote as UpdateCallNote } from '../../domain/call/note.action';
    import ButtonRounded from '../../common/ButtonRounded.svelte';

    let calls = {};
    let call = {};
    let total_page = 1;
    let page = 0;
    let loaders = {};
    let play = false;
    let counter = null;
    let playTime = 0;
    let editNote = false
    let note = ''
    let audio = new Audio('https://outlinks.pressone.co/p0p');
    const navigate = useNavigate()

    const groupByDate = (calls) => {
        return calls.reduce((acc, call) => {
            const date = new Date(call.start_time).toDateString();
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(call);
            return acc;
        }, {});
    };

    const playAudio = () => {
      audio.play();
      play = true
      counter = setInterval(() => {
        if ( playTime >= call.duration_secs ) {
          playTime = 0;
          play = false;
          clearInterval(counter)
        }
        playTime += 1;
      }, 1000);
    };

    const pauseAudio = () => {
      audio.pause()
      play = false
      clearInterval(counter)
    };

    const audioClicked = () => {
      if ( play ) {
        pauseAudio()
      } else {
        playAudio()
        AmplitudeLogger.log(EVENTS.RECORDINGS_PLAYED)
      }
    };

    const getTimeFormat = (duration) => {
      return `${String(Math.floor((duration === 0 ? 1 : duration)/60)).padStart(2, "0")}:${String(duration % 60).padStart(2, "0")}`
    }

    const formatDuration = (duration) => {
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const loadMoreLogs = async () => {
        loaders.getCallLogs = true
        try {
            const { data, nb_pages, page_size, page_index } = await GetCallLogs($sessionStore.receiver.business_number.id, page+1)
            const grouped_calls = groupByDate(data)
            
            for (const date in grouped_calls) {
                calls[date] = (date in calls) ? [...calls[date], ...grouped_calls[date]] : grouped_calls[date]
            }

            total_page = nb_pages
            page = page_index
        } catch (error) {
            console.log(error)
        } finally {
            loaders.getCallLogs = false
        }
    }

    const bg_colors = ['from-green-400 to-blue-500', 'from-yellow-400 to-purple-500', 'from-sky-400 to-blue-500', 'from-orange-400 to-red-500', 'from-red-400 to-pink-500']


    const getCallRecordingLink = (sip_call_id) => {
        return `https://storage.googleapis.com/pressonedotco/voice-message-recordings/${sip_call_id}.wav`
    }

    const selectCall = async (log) => {
        call = log;
        audio = new Audio(getCallRecordingLink(log.sip_call_id));
        await getCallLog()
        AmplitudeLogger.log(EVENTS.OPEN_CALL_RECORD)
    }

    const resetCall = () => {
        call = {}
        play = false;
        counter = null;
        playTime = 0;
        audio = new Audio('https://outlinks.pressone.co/p0p');
    }

    const getCallLog = async () => {
        loaders.getCallLog = true;
        try {
            const { data } = await GetCallLog($sessionStore.profile.business.id, $sessionStore.receiver.business_number.id, call.sip_call_id)
            call = data
        } catch (error) {}
        finally {
            loaders.getCallLogs = false
        }
    }

    const handleEditNote = () => {
        if (call.note) {
            note = call.note.note
            toast.warn(`There is already an existing note for this call log.`)
            // return
        } else {
            note = ''
        }
        editNote = true
    }

    const handleCopyRecordingLink = (call) => {
        copyText(getCallRecordingLink((call.sip_call_id)))
        AmplitudeLogger.log(EVENTS.RECORDINGS_COPIED)
    }

    const saveNote = async () => {
        loaders.saveCallNote = true
        try {
            const { sip_call_id: call_id, id: call_log_id } = call
            const payload = { 
                call_id, 
                call_log_id, 
                note
            }
            const data = call.note ? await UpdateCallNote(payload) : await SaveCallNote(payload) 
            call.note = data
            editNote = false
        } catch (e) {
            toast.warn(`Note not saved yet!. Please try again later.`)
        } finally {
            loaders.saveCallNote = false
        }
        AmplitudeLogger.log(EVENTS.NOTE_SAVED);
    }


    onMount( async () => {
        await loadMoreLogs()
    })
    
</script>

{#if Object.values(call).length > 0}
<div class="absolute top-0 w-full z-50 bg-white" in:fly={{
    y: 100,
    delay: 100,
    easing: backInOut
  }}
>
    <div class="p-4 bg-gray-100">
        <div class="flex justify-between w-full items-center">
          <div class="flex">
            <div class="flex justify-center items-center bg-gradient-to-r from-green-400 to-blue-500 rounded-full h-12 w-12 text-white">
                { call.caller_name ? pickOutInitials(call.caller_name) : 'N/A' }
            </div>
            <div class="text-sm ml-1">
              <p>{`${call.caller_name || 'N/A'}`}</p>
              <span class="text-xs">{ call.recipient_number }</span>
            </div>
          </div>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={resetCall}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>        
          </span>
        </div>
    </div>
    <div class="m-4">
        <div class="p-4 bg-gray-100 rounded mb-2">
            <p class="text-sm">
                {new Date(call.date_created).toDateString()}
            </p>
            <div class="flex flex-row mt-1">
                <span class="text-gray-500 text-xs basis-1/4">
                    { moment(new Date(call.date_created)).format('LT') }
                    <!-- {new Date(call.date_created).toLocaleTimeString()} -->
                </span>
                <div class="basis-3/4">
                    <div class="flex text-gray-600 text-sm flex-row items-center">
                        <span class="flex basis-2/3 flex-row items-center">
                            {#if call.is_answered && !call.is_dialed }
                                <Icon icon="incoming"/>
                            {:else if call.is_dialed}
                                <Icon icon="incoming"/>
                            {:else if call.is_forwarded_call}
                                <Icon icon="outgoing"/>
                            {:else if call.is_missed_call}
                                <Icon icon="missed"/>
                            {/if}
                            &nbsp;
                            {#if call.is_answered && !call.is_dialed }
                                Incoming
                            {:else if call.is_dialed}
                                Outgoing
                            {:else if call.is_forwarded_call}
                                Forwarded
                            {:else if call.is_missed_call}
                                Missed
                            {/if}
                            call
                        </span>
                        <strong class="basis-1/3 ml-1">{ call.user?.split(' ')[0] }</strong>
                    </div>
                    <div class="text-gray-500 text-xs">{formatDuration(call.duration_secs) || '00:00:00'}</div>
                </div>
            </div>
        </div>
        <h4 class="mt-2 flex justify-between">
            Recording 
            <button class="flex py-2 px-2 rounded text-xs items-center {call.duration_secs <= 0 ? 'opacity-50 cursor-not-allowed' : ''}" 
                on:click={handleCopyRecordingLink(call)} 
                disabled={call.duration_secs <= 0}>
                Share Call Details <Icon icon="copy" />
            </button>
        </h4>
        <div class="border-b my-2">
            <div class="audio border border-sky-400 rounded-md py-2 px-4 bg-sky-100 flex justify-between items-center mb-4">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div on:click={audioClicked}>
                    <Icon icon="play"/>
                </div>
                <div class="mt-1 flex justify-between items-center mx-8 grow">
                    {#each Array.from({length: 28}, (_, i) => i + 1) as v, k}
                    <div class="bar {Math.ceil((v/28)*call.duration_secs) < playTime ? 'bg-sky-700' : 'bg-gray-400'}" style="height: {(Math.floor(Math.random() * 40) + 5)}px"></div>
                    {/each}
                </div>
                <div>
                    { getTimeFormat(playTime) } <br/> 
                    <small>{ getTimeFormat(call.duration_secs) }</small>
                </div>
            </div>
        </div>

        <h4 class="">Notes</h4>
        <div class="border-b my-2 text-gray-500">
            {#if !editNote}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div class="p-4 bg-gray-100 rounded mb-2" on:click={handleEditNote}>
                    {#if !call.note }
                        <span>No call note yet! <i class="text-xs text-gray-400">click here to add note</i></span>
                    {:else}
                        <div>
                            <p class="text-xs text-gray-900">
                                { call.note.call_agent }
                                <br/>
                                <span class="text-gray-500">
                                    { moment(new Date(call.note.last_modified)).fromNow() }
                                </span>
                            </p>
                            <hr/>
                            <p class="mt-1">
                                { call.note.note }
                            </p>
                        </div>
                    {/if}
                </div>
            {:else}
                <div class="bg-gray-100 rounded mb-2 flex justify-center items-center">
                    <textarea 
                        placeholder="Type note here..." 
                        bind:value={note} 
                        class="border-none border-box w-full p-2 bg-gray-100 text-xs focus:outline-0"
                        style="height: 60px"
                    />
                    <ButtonRounded
                        loading={loaders.saveCallNote}
                        on:click={saveNote}
                        size=8
                        title=""
                        className="call-btn-bg-color text-xs flex-inline text-white px-4 py-2 m-2"
                    >Save</ButtonRounded>
                </div>
            {/if}
        </div>
    </div>
</div>
{/if}

<AuthHeader />
<div class="flex h-full flex-col mx-4">
    <h3 class="text-md font-bold mt-2 secondary-text-color">Call Records</h3>
    <div class="pb-40 overflow-y-scroll h-auto" style="height: 20rem;">
        {#each Object.entries(calls) as [date, logs], i}
        <div class="">
            <p class="text-left w-100 date my-3 text-gray-500 font-lighter primary-text-color">{ date }</p>
            <hr />
            <ul class="call-logs mt-2">
                {#each logs as log, j}
                <li class="flex justify-between my-5">
                    <div class="flex">
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <div 
                            class="flex justify-center items-center bg-gradient-to-r {bg_colors[(+i+j)%bg_colors.length]} rounded-full h-12 w-12 text-white cursor-pointer"
                            on:click={() => navigate("/add-contact", {state: log.contact})}
                        >
                            { log.caller_name ? pickOutInitials(log.caller_name) : 'N/A' }
                        </div>
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <div class="ml-2 cursor-pointer" on:click={initiateCall(formatNumber(log.recipient_number), {})}>
                            <div class="font-light" style="max-width: 135px;">{ log.caller_name || log.recipient_number }</div>
                            <div class="text-gray-500 text-sm flex">
                                <span class="flex justify-center items-center mr-1">
                                    {#if log.is_answered && !log.is_dialed }
                                        <Icon icon="incoming"/>
                                    {:else if log.is_dialed}
                                        <Icon icon="incoming"/>
                                    {:else if log.is_forwarded_call}
                                        <Icon icon="outgoing"/>
                                    {:else if log.is_missed_call}
                                        <Icon icon="missed"/>
                                    {/if}
                                </span>
                                <span>
                                    {#if log.is_answered && !log.is_dialed }
                                        Incoming
                                    {:else if log.is_dialed}
                                        Outgoing
                                    {:else if log.is_forwarded_call}
                                        Forwarded
                                    {:else if log.is_missed_call}
                                        Missed
                                    {/if}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="mr-2">
                            <div>{formatDuration(log.duration_secs) || '00:00:00'}</div>
                            <span class="text-gray-500 text-sm">
                                { moment(new Date(log.date_created)).format('LT') }
                                <!-- {new Date(log.date_created).toLocaleTimeString()} -->
                            </span>
                        </div>
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <div class="flex justify-center items-center" on:click={selectCall(log)}><Icon icon="info"/></div>
                    </div>
                </li>
                {/each}
            </ul>
        </div>
        {/each}
        <InfiniteScroll
            hasMore={page < total_page}
            threshold={5}
            on:loadMore={() => loadMoreLogs()}
        />
        {#if loaders.getCallLogs}
        <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
            <svg aria-hidden="true" class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <i class="animate-pulse secondary-text-color">loading record...</i>
        </div>
        {/if}
    </div>
    
</div>
<AuthFooter />
<style lang="scss">
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .audio {
        .bar {
            width: 2.5px;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            cursor: pointer;
        }
    }
</style>
